export const catalogOptions = {
  title: {
    default: 'QLOGIC',
    ko: '큐로직',
  },
  langSet: ['ko', 'en'],
  pageMap: [
    'Cover',
    'Intro',
    'QP-service/Competitiveness',
    'QP-service/BizCapability',
    'QP-service/Highlight',
    'QP-service/ServiceModels',
    'Company/Overview',
    'Company/Vision',
    'Company/Manpower',
    'Company/BI',
    'Last',
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  responsiveMode: true,
  breakpoint: 768,
};

export const easing = {
  pop: [0.85, 0.14, 0.29, 0.99],
};

export const aniTemp = {
  transition: {
    pop: { ease: easing.pop, duration: 0.5 },
    spring: { type: 'spring', bounce: 1, damping: 10, mass: 0.5, stiffness: 90 },
  },
  fadein: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
  },
  fadeleft: {
    initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0 },
  },
  faderight: {
    initial: { opacity: 0, x: -100 },
    animate: { opacity: 1, x: 0 },
  },
  fadeup: {
    initial: { opacity: 0, y: 100 },
    animate: { opacity: 1, y: 0 },
  },
  fadedown: {
    initial: { opacity: 0, y: -100 },
    animate: { opacity: 1, y: 0 },
  },
  scaleup: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
  },
  scaledown: {
    initial: { opacity: 0, scale: 1.2 },
    animate: { opacity: 1, scale: 1 },
  },
};
